import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BarcodeScannerComponent } from './view/barcode-scanner/barcode-scanner.component';
import { BrowserModule } from '@angular/platform-browser';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

@NgModule({
    declarations: [
        BarcodeScannerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        BrowserModule,
        ZXingScannerModule
    ],
    exports: [
        BarcodeScannerComponent
    ],
    entryComponents: [
        BarcodeScannerComponent
    ]

})
export class BarcodeScannerModule { }
